'use client';
import React, { useState, useEffect } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { store, persistor } from '../store';
import { PersistGate } from 'redux-persist/integration/react';
import { useSessionRefresher } from '@/_lib/client/hooks/useSessionRefresher';

function SessionInitializer({ onReady }: { onReady: () => void }) {
  const { ready } = useSessionRefresher();

  useEffect(() => {
    if (ready) {
      onReady();
    }
  }, [ready, onReady]);

  return null;
}

export function AppProvider({ children }: { children: React.ReactNode }) {
  const [isReady, setIsReady] = useState(false);

  return (
    <ReduxProvider store={store}>
      {/* Don't mount PersistGate until session refresh completes */}
      {isReady ? (
        <PersistGate loading={null} persistor={persistor}>
          {children}
        </PersistGate>
      ) : (
        <SessionInitializer onReady={() => setIsReady(true)} />
      )}
    </ReduxProvider>
  );
}
